import { Box, TextField } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";

const setNumberHaulsPattern = function (validationData) {
  if (
    validationData &&
    validationData.hasOwnProperty("HAULS_MINIMUM") &&
    validationData.hasOwnProperty("HAULS_MAXIMUM")
  ) {
    return validationData.HAULS_MINIMUM + " - " + validationData.HAULS_MAXIMUM;
  }
  return "no valid pattern";
};
export default function NrHauls(props) {
  return (
    <Box mt={0} width="100%" align="center">
      <h2 className="sectionTitle center">Number of Hauls</h2>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md="auto">
          <FormControl>
            <TextField
              variant="standard"
              label="Number of Hauls:"
              className="number-of-input"
              inputProps={{ min: 0, style: { textAlign: "center" } }}
              value={props.number_of_hauls ? Number(props.number_of_hauls) : ""}
              name="number_of_hauls"
              type="number"
              onChange={(e) => props.handleInputChange(e)}
              helperText={setNumberHaulsPattern(props.validation)}
            />
          </FormControl>
          <HelpText helpText={getHelpText(props.helpText, "num_hauls")} />
        </Grid>
      </Grid>
    </Box>
  );
}
